// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3S3A3","validationTips":"StatementDescriptor_validationTips__3rtsO"};